import { useState } from "react";
import styles from "./InteractionLottie.module.scss";

import Lottie from "react-lottie-player";
import { isMobileDevice } from "../../../../../../utils/getPlatformInfo";

const segmentData = {
  handleBtn: [
    {
      start: 1,
      end: 96,
    },
  ],
};

const InteractionLottie = ({ lottieData, play, setPlay }) => {
  const [segmentFrom, setSegmentFrom] = useState(
    segmentData.handleBtn[0].start
  );

  const [segmentTo, setSegmentTo] = useState(segmentData.handleBtn[0].end);
  const [segmentsEnabled, setSegmentsEnabled] = useState(true);

  const [loop, setLoop] = useState(false);
  const [speed, setSpeed] = useState(1);
  const [goTo, setGoTo] = useState(0);
  const [direction, setDirection] = useState(1);

  const segments = [segmentFrom, segmentTo];

  const handleLoad = (e) => {
    // console.log("load", e);
  };

  const handleSegmentStart = (e) => {
    // console.log("handleSegmentStart", e);
  };

  const handleLoopComplete = (e) => {
    // console.log("loopComplete", e);
  };
  const handleEnterFrame = (e) => {};

  const handleComplete = (e) => {
    setPlay(false);
  };

  return (
    <Lottie
      className={`${styles.container} ${play ? styles.scaleUp : ""}`}
      loop={loop}
      play={play}
      speed={speed}
      goTo={goTo}
      direction={direction}
      segments={segmentsEnabled && segments}
      animationData={!isMobileDevice ? lottieData : lottieData}
      onComplete={handleComplete}
      onLoopComplete={handleLoopComplete}
      onEnterFrame={handleEnterFrame}
      onSegmentStart={() => handleSegmentStart("segmentStart")}
      onLoad={handleLoad}
    />
  );
};

export default InteractionLottie;
